// Client-side search matcher for the campaign wizard "Screens" tab, used when
// screens are filtered locally (edit mode / "show selected screens").
//
// Mirrors the backend `q` behaviour: the whole text is matched as a substring,
// and additionally each whitespace/comma separated term is matched exactly
// against the external id, so several ids can be pasted at once
// ("tgx_524 tgx_526").

const TOKEN_SEPARATOR = /[\s,;]+/;

export const parseSearchTokens = (search) =>
    Array.from(
        new Set(
            String(search ?? '')
                .split(TOKEN_SEPARATOR)
                .map((token) => token.trim())
                .filter(Boolean)
        )
    );

export const screenMatchesSearch = (screen, search) => {
    const normalized = String(search ?? '')
        .trim()
        .toLowerCase();
    if (!normalized) return true;

    const values = [
        screen?.name,
        screen?.alias,
        screen?.external_id,
        screen?.externalId,
    ].map((value) => String(value ?? '').toLowerCase());

    if (values.some((value) => value.includes(normalized))) return true;

    const tokens = parseSearchTokens(normalized);
    if (tokens.length < 2) return false;
    return tokens.some((token) => values.includes(token));
};
